// @mui material components
import {
  Snackbar,
  Alert,
  AlertTitle,
  Grid,
  Card,
  Icon,
  // Tooltip,
  CircularProgress,
  Backdrop,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  Table,
  TableRow,
  TableBody,
  TableCell,
  // TableContainer,
  // Paper,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  LinearProgress,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
// import MDBadge from "theme/components/MDBadge";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useAuthUser } from "react-auth-kit";

import BalanceOverviewCard from "app/wallet/BalanceOverviewCard";
import Transaction from "app/wallet/Transaction";
import { useEffect, useState } from "react";
import axios from "axios.js";
import { Link } from "react-router-dom";
import usePageTitle from "app/pageTitle";
import CompanyNotification from "app/company_notification";
import AppConfig from "appConfig";

import PushNotificationMgr from "app/components/push_notification_mgr";

// import { confirm } from "react-confirm-box";

function Wallet() {
  // const { currency } = useParams();

  const pageTitle = `Wallet`;
  usePageTitle(pageTitle);

  const auth = useAuthUser();
  const accountInfo = auth();

  // const [controller] = useMaterialUIController();
  // const { darkMode } = controller;

  // const navigate = useNavigate();

  function emptyCache() {
    if ("caches" in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
  }

  function versionRefresh() {
    emptyCache();
    window.location.reload();
  }

  function appVersionCheck(newVersion) {
    // Handle App Update
    const currentVersion = localStorage.getItem(AppConfig.app_version_store);
    let shouldUpdate = false;
    if (currentVersion !== newVersion) {
      shouldUpdate = true;
    }
    localStorage.setItem(AppConfig.app_version_store, newVersion);

    if (shouldUpdate) {
      if (
        window.confirm(
          "A new version is available. App will automatically refresh to get the latest update."
        ) === true
      ) {
        versionRefresh();
      } else {
        versionRefresh();
      }
    }
  }

  const [currency, setCurrency] = useState({});
  const [balance, setBalance] = useState(null);
  const [isAleroLinked, setIsAleroLinked] = useState(false);
  const [transactions, setTransactions] = useState(null);
  const [vbank, setVbank] = useState(null);

  const [showCompanyNotification, setShowCompanyNotification] = useState(false);
  const [companyNotification, setCompanyNotification] = useState(null);

  const [openVbankDialog, setOpenVbankDialog] = useState(false);
  const [openWithdrawDialog, setOpenWithdrawDialog] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState(null);
  const [destinationType, setDestinationType] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [accountNumber, setAccountNumber] = useState(null);
  const [accountName, setAccountName] = useState(null);
  const [banks, setBanks] = useState([]);
  const [showInlineLoading, setShowInlineLoading] = useState(false);
  const [withdrawalFeesObject, setWithdrawalFeesObject] = useState({});
  const [withdrawalFee, setWithdrawalFee] = useState(null);

  // const [subscribeBtnLabel, setSubscribeBtnLabel] = useState("Subscribe");
  // const [currentSubscription, setCurrentSubscription] = useState(null);
  const [subscriptionPaymentDuration, setSubscriptionPaymentDuration] = useState(null);
  const [openSubscriptionPaymenttDialog, setOpenSubscriptionPaymenttDialog] = useState(false);

  const [refreshPage, setRefreshPage] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  useEffect(() => {
    if (destinationType === null) {
      return;
    }

    // if (destinationType === "ALERO") {
    //   setWithdrawalFee("FREE");
    // } else {
    //   setWithdrawalFee("N75.00");
    // }
    setWithdrawalFee(withdrawalFeesObject[destinationType]);
  }, [destinationType]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/wallet.json`)
        .then((result) => {
          setShowLoading(false);
          // console.log(result);
          if (result.data.status === "success") {
            setCurrency(result.data.data.currency);
            setBalance(result.data.data.balance);
            setTransactions(result.data.data.entries);
            setIsAleroLinked(result.data.data.aleroEnabled);
            setVbank(result.data.data.vbank);
            setBanks(result.data.data.banks);
            setWithdrawalFeesObject(result.data.data.withdrawal_fee);
            // setCurrentSubscription(result.data.data.subscription);
            // if (result.data.data.subscription === null) {
            //   setSubscribeBtnLabel("Subscribe");
            // } else {
            //   setSubscribeBtnLabel("Subscribe");
            //   if (result.data.data.subscription.status) {
            //     setSubscribeBtnLabel("Renew");
            //   }
            // }

            if (result.data.notification) {
              setCompanyNotification(result.data.notification);
              if (result.data.notification.pages.includes("ALL")) {
                setShowCompanyNotification(true);
              } else if (result.data.notification.pages.includes("wallet")) {
                setShowCompanyNotification(true);
              }
            }
          } else {
            setErrMsg(result.data.data.message);
            setSeverity("error");
            setOpen(true);
          }

          appVersionCheck(result.data.version);
        })
        .catch(() => {
          setShowLoading(false);
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setSeverity("error");
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function paySubscription() {
    if (subscriptionPaymentDuration == null || subscriptionPaymentDuration <= 0) {
      setSeverity("error");
      setErrMsg("Please select a duration");
      setOpen(true);
      return;
    }

    setOpenSubscriptionPaymenttDialog(false);
    setShowLoading(true);
    const json = {
      duration: subscriptionPaymentDuration,
    };

    await axios
      .post("agents/license/subscription/pay.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function vbankCreate() {
    setShowLoading(true);
    const json = {};

    await axios
      .post("agents/vbank/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function fetchAccountName() {
    setShowInlineLoading(true);
    const json = {
      bank_code: selectedBank,
      account_number: accountNumber,
    };

    await axios
      .post("agents/wallet/withdraw/getAccountName.json", json)
      .then((result) => {
        setShowInlineLoading(false);
        if (result.data.status === "success") {
          setAccountName(result.data.data.account_name);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowInlineLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const bankDetailsChange = () => {
    setAccountName(null);
    if (selectedBank !== null && accountNumber !== null) {
      fetchAccountName();
    }
  };

  async function withdrawFunds() {
    if (withdrawAmount === null || withdrawAmount <= 0) {
      setSeverity("error");
      setErrMsg("Invalid amount entered.");
      setOpen(true);
      return;
    }

    if (destinationType === null) {
      setSeverity("error");
      setErrMsg("Destination type is required");
      setOpen(true);
      return;
    }

    let destinationObject = {};
    if (destinationType === "BANK") {
      if (selectedBank === null) {
        setSeverity("error");
        setErrMsg("Bank is required");
        setOpen(true);
        return;
      }

      if (accountNumber === null) {
        setSeverity("error");
        setErrMsg("Account number is required");
        setOpen(true);
        return;
      }

      if (accountName === null) {
        setSeverity("error");
        setErrMsg("Account name not found");
        setOpen(true);
        return;
      }

      destinationObject = {
        bank_code: selectedBank,
        account_number: accountNumber,
        account_name: accountName,
      };
    }

    if (destinationType === "ALERO") {
      if (!isAleroLinked) {
        setSeverity("error");
        setErrMsg("Please link an Alero account to your wallet.");
        setOpen(true);
        return;
      }
    }

    setOpenWithdrawDialog(false);
    setShowLoading(true);
    const json = {
      amount: withdrawAmount * 100,
      currency: "NGN",
      destination: {
        type: destinationType,
        destination: destinationObject,
      },
    };

    await axios
      .post("agents/wallet/withdraw.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const [allowPushNotificationDialogState, setAllowPushNotificationDialogState] = useState(false);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PushNotificationMgr
        displayState={allowPushNotificationDialogState}
        setDisplayState={setAllowPushNotificationDialogState}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {companyNotification !== null && showCompanyNotification ? (
        <CompanyNotification
          title={companyNotification.title}
          description={companyNotification.description}
        />
      ) : (
        <> </>
      )}
      {vbank ? (
        <Dialog open={openVbankDialog}>
          <DialogTitle>
            <MDBox>Deposit Bank Account</MDBox>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <MDBox>Pay to the bank details below to fund your Laddar wallet.</MDBox>
            </DialogContentText>
            <MDBox mt={3}>
              <MDBox>
                <Table aria-label="bank information">
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <MDTypography variant="h6" fontWeight="medium">
                          Bank Name
                        </MDTypography>
                      </TableCell>
                      <TableCell align="right">
                        <MDTypography variant="h6" fontWeight="light">
                          {vbank.bank_name}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <MDTypography variant="h6" fontWeight="medium">
                          Account Name
                        </MDTypography>
                      </TableCell>
                      <TableCell align="right">
                        <MDTypography variant="h6" fontWeight="light">
                          {vbank.account_name}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <MDTypography variant="h6" fontWeight="medium">
                          Account Number
                        </MDTypography>
                      </TableCell>
                      <TableCell align="right">
                        <MDTypography variant="h6" fontWeight="light">
                          {vbank.account_number}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenVbankDialog(false);
              }}
              color="dark"
              variant="outlined"
            >
              Close
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <Dialog open={openVbankDialog}>
          <DialogTitle>
            <MDBox>Deposit Bank Account</MDBox>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <MDBox>You have not created your wallet deposit bank account.</MDBox>
            </DialogContentText>
            <MDBox mt={1} p={3}>
              <ul>
                <li>Fund wallet</li>
                <li>Accept cash from customers</li>
                <li>Laddar wallet will be debitted</li>
                <li>Sold product displayed and sent to customer email</li>
              </ul>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenVbankDialog(false);
              }}
              color="dark"
              variant="outlined"
            >
              Close
            </MDButton>
            <MDButton
              onClick={() => {
                setOpenVbankDialog(false);
                vbankCreate();
              }}
              color="success"
              variant="outlined"
            >
              Create
            </MDButton>
          </DialogActions>
        </Dialog>
      )}
      <Dialog open={openWithdrawDialog}>
        <DialogTitle>
          <MDBox>Funds Withdrawal</MDBox>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDBox>Withdraw funds to your Alero Account or Bank Account</MDBox>
          </DialogContentText>
          <MDBox mt={2}>
            <MDInput
              name="amount"
              margin="dense"
              label="Enter Amount"
              type="decimal"
              fullWidth
              variant="outlined"
              onChange={(e) => setWithdrawAmount(e.target.value)}
            />
          </MDBox>
          <MDBox mt={3}>
            <FormControl sx={{ minWidth: 120, width: "100%" }}>
              <InputLabel>Withdraw To</InputLabel>
              <Select
                label="Withdraw To"
                onChange={(e) => {
                  setDestinationType(e.target.value);
                }}
                sx={{ padding: "12px", paddingLeft: "3px" }}
              >
                <MenuItem value="ALERO">Alero Account</MenuItem>
                <MenuItem value="BANK">Bank Account</MenuItem>
              </Select>
            </FormControl>
          </MDBox>
          {withdrawalFee !== null && destinationType !== null ? (
            <MDBox mt={1} align="right">
              <MDTypography variant="caption" fontWeight="medium" color="info">
                Fee: {withdrawalFee}
              </MDTypography>
            </MDBox>
          ) : (
            <> </>
          )}
          {destinationType === "BANK" ? (
            <MDBox>
              <MDBox mt={4} mb={3}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Bank</InputLabel>
                  <Select
                    label="Bank"
                    onBlur={bankDetailsChange}
                    onChange={(e) => {
                      setSelectedBank(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {
                      // --> Notice below changes
                      banks.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        banks.map((record) => (
                          <MenuItem value={record.sort_code}>{record.title}</MenuItem>
                        ))
                    }
                  </Select>
                </FormControl>
              </MDBox>
              <MDBox mt={2}>
                <MDInput
                  name="amount"
                  margin="dense"
                  label="Account Number"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setAccountNumber(e.target.value)}
                  onBlur={bankDetailsChange}
                />
              </MDBox>
              {showInlineLoading ? (
                <MDBox m={3}>
                  &nbsp;&nbsp;
                  <LinearProgress color="info" />
                </MDBox>
              ) : (
                <> </>
              )}
              {accountName !== null ? (
                <MDBox mt={2}>
                  <MDInput
                    value={accountName}
                    disabled
                    readOnly
                    name="accountName"
                    margin="dense"
                    label="Account Name"
                    type="text"
                    fullWidth
                    variant="outlined"
                  />
                </MDBox>
              ) : (
                <> </>
              )}
            </MDBox>
          ) : (
            <> </>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenWithdrawDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Close
          </MDButton>
          <MDButton
            onClick={() => {
              // setOpenWithdrawDialog(false);
              withdrawFunds();
            }}
            color="error"
            variant="outlined"
          >
            Withdraw
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openSubscriptionPaymenttDialog}>
        <DialogTitle>
          <MDBox>Subscription Payment</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDTypography variant="text" fontWeight="light" mb={3}>
            Gain access to join and sell on open campaigns available monthly.
          </MDTypography>
          <MDBox mt={1} mb={3}>
            <MDBox mt={4}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>License Duration</InputLabel>
                <Select
                  label="License Duration"
                  onChange={(e) => {
                    setSubscriptionPaymentDuration(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {/* <MenuItem value="ALERO">Alero Account</MenuItem> */}
                  <MenuItem value="1">1 Month</MenuItem>
                  <MenuItem value="3">3 Months</MenuItem>
                  <MenuItem value="6">6 Months</MenuItem>
                  <MenuItem value="12">12 Months</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenSubscriptionPaymenttDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              if (window.confirm(`Proceed with payment? Your balance with be debited.`) === true) {
                paySubscription();
              }
            }}
          >
            Pay Now
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {balance != null ? (
              <>
                {" "}
                {!isAleroLinked ? (
                  <MDBox mb={5} mr={1}>
                    <Alert severity="error" sx={{ width: "100%" }}>
                      <AlertTitle>ALERO Account Required</AlertTitle>
                      Go to your profile page to link an Alero Account.{" "}
                      <Link to="/profile">My Profile</Link>
                    </Alert>
                  </MDBox>
                ) : (
                  <> </>
                )}
              </>
            ) : (
              <> </>
            )}

            {/* <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox mb={1.5}>
                  <MDBox mb={2.5}>
                    <BalanceOverviewCard
                      idx="balance"
                      color="success"
                      icon="account_balance_wallet"
                      // currencyCode={currency}
                      symbol={currency.symbol}
                      amount={balance}
                      title="Balance"
                    />
                  </MDBox>
                  <MDBox mt={5}>
                    <Card sx={{ width: "100%" }}>
                      <MDBox p={3}>
                        <Grid container spacing={2}>
                          <Grid item xs={6} md={6} lg={6}>
                            <MDBox display="flex" justifyContent="center">
                              <MDButton
                                variant="outlined"
                                color="success"
                                onClick={() => {
                                  // if (!vbank) {
                                  //   setErrMsg("Please link your Alero account to enable this feature.");
                                  //   setSeverity("error");
                                  //   setOpen(true);
                                  //   return;
                                  // }

                                  setOpenVbankDialog(true);
                                }}
                              >
                                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                                &nbsp;Deposit
                              </MDButton>
                            </MDBox>
                          </Grid>
                          <Grid item xs={6} md={6} lg={6}>
                            <MDBox display="flex" justifyContent="center">
                              <MDButton
                                variant="outlined"
                                color="error"
                                onClick={() => {
                                  if (!isAleroLinked) {
                                    setErrMsg(
                                      "Please link your Alero account to enable this feature."
                                    );
                                    setSeverity("error");
                                    setOpen(true);
                                    return;
                                  }

                                  setDestinationType(null);
                                  setSelectedBank(null);
                                  setAccountNumber(null);
                                  setAccountName(null);
                                  setWithdrawAmount(null);
                                  setWithdrawalFee(null);
                                  setOpenWithdrawDialog(true);
                                }}
                              >
                                <Icon sx={{ fontWeight: "bold" }}>send</Icon>
                                &nbsp;Withdraw
                              </MDButton>
                            </MDBox>
                          </Grid>
                        </Grid>
                      </MDBox>
                    </Card>
                  </MDBox>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox align="right">
                  <Card sx={{ width: "100%", minHeight: "220px" }}>
                    <MDBox p={1} align="center">
                      <MDBox>
                        <Icon color="warning" fontSize="large">
                          support_agent
                        </Icon>
                      </MDBox>
                      <MDTypography variant="h6" fontWeight="medium">
                        License Subscription
                      </MDTypography>
                      {currentSubscription ? (
                        <MDBox>
                          <MDTypography variant="h6" fontWeight="light">
                            <MDBadge
                              badgeContent={currentSubscription.status ? "ACTIVE" : "EXPIRED"}
                              variant="contained"
                              container
                              color={currentSubscription.status ? "success" : "error"}
                            />
                          </MDTypography>
                          <MDBox mt={1}>
                            <MDTypography variant="h6" fontWeight="light">
                              Expires On
                              <br />
                              <b>{currentSubscription.expires_on}</b>
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      ) : (
                        <MDBox mb={3}>
                          <MDTypography variant="h6" fontWeight="light">
                            No active subscription. Pay now to activate your plan.
                          </MDTypography>
                        </MDBox>
                      )}
                      <MDBox mt={1} mb={0.5}>
                        <MDButton
                          size="small"
                          variant="outlined"
                          color="success"
                          onClick={() => {
                            setSubscriptionPaymentDuration(null);
                            setOpenSubscriptionPaymenttDialog(true);
                          }}
                        >
                          <Icon sx={{ fontWeight: "bold" }}>send</Icon>
                          &nbsp; {subscribeBtnLabel}
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid> */}
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <MDBox>
                    <BalanceOverviewCard
                      idx="balance"
                      color="success"
                      icon="account_balance_wallet"
                      // currencyCode={currency}
                      symbol={currency.symbol}
                      amount={balance}
                      title="Balance"
                    />
                  </MDBox>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card sx={{ width: "100%" }}>
                    <MDBox p={3}>
                      <Grid container spacing={2}>
                        <Grid item xs={6} md={6} lg={6}>
                          <MDBox display="flex" justifyContent="center">
                            <MDButton
                              variant="outlined"
                              color="success"
                              startIcon={<Icon sx={{ fontWeight: "bold" }}>add</Icon>}
                              onClick={() => {
                                // if (!vbank) {
                                //   setErrMsg("Please link your Alero account to enable this feature.");
                                //   setSeverity("error");
                                //   setOpen(true);
                                //   return;
                                // }

                                setOpenVbankDialog(true);
                              }}
                            >
                              Deposit
                            </MDButton>
                          </MDBox>
                        </Grid>
                        <Grid item xs={6} md={6} lg={6}>
                          <MDBox display="flex" justifyContent="center">
                            <MDButton
                              variant="outlined"
                              color="error"
                              startIcon={<Icon sx={{ fontWeight: "bold" }}>send</Icon>}
                              onClick={() => {
                                if (!isAleroLinked) {
                                  setErrMsg(
                                    "Please link your Alero account to enable this feature."
                                  );
                                  setSeverity("error");
                                  setOpen(true);
                                  return;
                                }

                                setDestinationType(null);
                                setSelectedBank(null);
                                setAccountNumber(null);
                                setAccountName(null);
                                setWithdrawAmount(null);
                                setWithdrawalFee(null);
                                setOpenWithdrawDialog(true);
                              }}
                            >
                              Withdraw
                            </MDButton>
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <Card sx={{ width: "100%", marginTop: "35px" }}>
                  <MDBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    pt={3}
                    px={2}
                  >
                    <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                      Recent Transactions
                    </MDTypography>
                    <MDBox alignContents="center">
                      <MDButton
                        variant="outlined"
                        size="small"
                        color="info"
                        startIcon={<Icon sx={{ fontWeight: "bold" }}>download</Icon>}
                        onClick={() => {
                          window.location.replace(
                            `${AppConfig.api_base_url}agents/wallet/statement/${accountInfo.reference}.json`
                          );
                        }}
                      >
                        Statement
                      </MDButton>
                    </MDBox>
                  </MDBox>
                  {transactions === null ? (
                    <MDBox pt={3} pb={2} px={2}>
                      <MDBox
                        component="ul"
                        display="flex"
                        flexDirection="column"
                        p={0}
                        m={0}
                        sx={{ listStyle: "none" }}
                      >
                        No recent transactions found
                      </MDBox>
                    </MDBox>
                  ) : (
                    <MDBox pt={3} pb={2} px={2}>
                      <MDBox
                        component="ul"
                        display="flex"
                        flexDirection="column"
                        p={0}
                        m={0}
                        sx={{ listStyle: "none" }}
                      >
                        {transactions.map((record, index) => (
                          <Grid item xs={12} md={12} lg={12}>
                            <MDBox mb={1.5}>
                              <Transaction
                                idx={index}
                                currency="₦"
                                entryType={record.entry_type}
                                narration={record.narration}
                                amount={record.amount}
                                created={record.created}
                              />
                            </MDBox>
                          </Grid>
                        ))}
                      </MDBox>
                    </MDBox>
                  )}
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Wallet;
